import { Mission } from '../types/mission';

const assertNever = (value: never): never => {
  throw new Error(`Unsupported mission type: ${String(value)}`);
};

const assertSupportedMissionType = (type: string): Mission['type'] => {
  if (type === 'coordinate' || type === 'move' || type === 'sequence') {
    return type;
  }
  throw new Error(`Unsupported mission type: ${type}`);
};

/**
 * Resolve the canonical route for a mission type.
 */
export const getMissionRoute = (mission: Mission): string => {
  const missionType = assertSupportedMissionType(mission.type);

  switch (missionType) {
    case 'sequence':
      return `/mission/sequence/${mission.id}`;
    case 'coordinate':
    case 'move':
      return `/mission/${mission.id}`;
    default:
      return assertNever(missionType as never);
  }
};
